<template>
  <section class="section section3m">
    <div class="section-wrap-m">
      <div class="s3-top">
        <h2 class="s3-title">{{$t('home.s3_1')}}</h2>
        <p class="s3-ps">{{$t('home.s3_2')}}</p>
        <div class="s3-realize-more">
          <div @click="routerSkip('/tech',1)" class="num-more clearfix"><span class="num-more-text">{{$t('common.more')}}</span><img src="@/assets/images/icon/more-point-right-w.png" class="more-icon"></div>
        </div>
      </div>
      <div class="s3-bottom">
        <div class="s3-swiper-box">
          <swiper v-if="prizeListFormat.length > 0" :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="item in prizeListFormat">
              <div class="prize-box-wrap clearfix">
                <div v-for="child in item" class="prize-box">
                  <div class="prize-box-bg">
                    <div class="prize-pic" :style="{backgroundImage:'url(' + child.patentImage + '?imageView2/2/w/400/interlace/1)'}"></div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="page-num">
            <a-icon type="arrow-left" class="point-icon point-left" />
            <a-icon type="arrow-right" class="point-icon point-right" />
            <span class="page-num-now">{{swiperIndex}}</span> <span class="page-num-total"> / {{prizeListFormat.length}}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
    import { selectPatent } from '@api/index'
  export default {
    name: 'homeSection3m',

    data () {
      return {
        swiperIndex: 1,
        swiperOption: {
          speed: 300,
          loop: true,
          nextButton: '.point-right',
          prevButton: '.point-left',
          onSlideChangeStart: swiper => {
            let num = swiper.realIndex + 1
            this.swiperIndex = num
          }
        },
          listQuery:{
              number:20,
              page:1,
              totalPage:1,
              total:18
          },
        prizeList: [{
          id: 1,
          patentImage: require('@/assets/images/tech/patent/1.jpg')
        },{
          id: 2,
          patentImage: require('@/assets/images/tech/patent/2.jpg')
        },{
          id: 3,
          patentImage: require('@/assets/images/tech/patent/3.jpg')
        },{
          id: 4,
          patentImage: require('@/assets/images/tech/patent/4.jpg')
        },{
          id: 5,
          patentImage: require('@/assets/images/tech/patent/5.jpg')
        },{
          id: 6,
          patentImage: require('@/assets/images/tech/patent/6.jpg')
        },{
          id: 7,
          patentImage: require('@/assets/images/tech/patent/7.jpg')
        },{
          id: 8,
          patentImage: require('@/assets/images/tech/patent/8.jpg')
        },{
          id: 9,
          patentImage: require('@/assets/images/tech/patent/9.jpg')
        },{
          id: 10,
          patentImage: require('@/assets/images/tech/patent/10.jpg')
        },{
          id: 11,
          patentImage: require('@/assets/images/tech/patent/11.jpg')
        },{
          id: 12,
          patentImage: require('@/assets/images/tech/patent/12.jpg')
        },{
          id: 13,
          patentImage: require('@/assets/images/tech/patent/13.jpg')
        },{
          id: 14,
          patentImage: require('@/assets/images/tech/patent/14.jpg')
        },{
          id: 15,
          patentImage: require('@/assets/images/tech/patent/15.jpg')
        },{
          id: 16,
          patentImage: require('@/assets/images/tech/patent/16.jpg')
        },{
          id: 17,
          patentImage: require('@/assets/images/tech/patent/17.jpg')
        },{
          id: 18,
          patentImage: require('@/assets/images/tech/patent/18.jpg')
        },{
          id: 19,
          patentImage: require('@/assets/images/tech/patent/19.jpg')
        },{
          id: 20,
          patentImage: require('@/assets/images/tech/patent/20.jpg')
        },{
          id: 21,
          patentImage: require('@/assets/images/tech/patent/21.jpg')
        }],
        prizeListFormat: []
      }
    },
    mounted () {
        this.listQuery.languageType = this.$i18n.locale
      this.getList()
    },
    methods: {
        getList() {
            let formatList = []
            selectPatent(this.listQuery).then(res=>{
                if(res.code==0){
                    res.data.list.forEach((val,index) => {
                        let num = Math.floor(index / 2)
                        if (typeof formatList[num] === 'object') {
                            formatList[num].push(val)
                        } else {
                            formatList[num] = []
                            formatList[num].push(val)
                        }
                    })
                    this.prizeListFormat = formatList
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
      // getList() {
      //   let formatList = []
      //   this.prizeList.forEach((val,index) => {
      //     let num = Math.floor(index / 2)
      //     if (typeof formatList[num] === 'object') {
      //       formatList[num].push(val)
      //     } else {
      //       formatList[num] = []
      //       formatList[num].push(val)
      //     }
      //   })
      //   this.prizeListFormat = formatList
      // }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section3m
    padding .9rem 0;background-image url("~@/assets/images/home/3-bg-m.jpg");bgCover()
  .s3-top
    rela();color #fff
    .s3-title
      font-size .4rem;color #fff
    .s3-ps
      margin-top .15rem;font-size .26rem;
    .num-more
      display block;abso();bottom 0;right 0;width: 1.5rem;height: .6rem;border-bottom .02rem solid #fff;text-align left;line-height .58rem;font-size:.24rem;
      .more-icon
        abso();top 0;bottom 0;right 0;margin: auto;width: .32rem;height: .22rem;
  .s3-bottom
    rela();margin-top .75rem;width: 100%;padding 0 .1rem;height: 5.75rem
    .s3-swiper-box
      rela();height: 100%
      .swiper-container
        height: 5.75rem
      .swiper-slide
        height:5.75rem;cursor -webkit-grab
        .prize-box
          fl();width 50%;padding 0 .03rem
          .prize-box-bg
            height: 5.75rem;padding-top .2rem;background-image url("~@/assets/images/home/prize-box.png");background-repeat no-repeat;background-position top center;background-size contain
          .prize-pic
            margin 0 auto;width: 2.7rem;height: 3.72rem;border-radius .05rem;bgCover()
  .page-num
    abso();bottom .5rem;left 0;right 0;margin: auto;width: 2.2rem;height: .4rem;text-align center;line-height .4rem;color #fff;z-index 1
  .page-num-now
    font-size .3rem
  .page-num-total
    font-size .2rem
  .point-icon
    display inline-block;abso();top -.1rem;bottom 0;margin: auto;width: .36rem;height: .24rem;font-size .36rem;cursor pointer
  .point-left
    left 0;
  .point-right
    right 0
</style>
